import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {FaConfig} from "@fortawesome/angular-fontawesome";

declare global {
  namespace Temporal {
    interface Instant {}
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent {

  readonly title = 'fizjo-strug';

  constructor() {
    inject(FaConfig).autoAddCss = false;
  }

}
